<template>
	<div class="display-message">
		<div class="customer-application-login-container">
			<div
				class="success-message-container"
				v-if="!$route.query.isInStore"
			>
				<div
					class="success-message-text"
					v-html="message1"
				></div>
			</div>
			<div
				class="success-message-container"
				v-if="$route.query.isInStore"
			>
				<div
					class="success-message-text"
					v-html="message2"
				></div>
				<a
					:href="hrefUrl"
					class="success-message-text"
					>{{ localization.creditApp.creationPage.startApplication[fimenu.language] }}</a
				>
				<div
					class="success-message-text"
					v-html="message3"
				></div>
			</div>
		</div>
	</div>
</template>

<script>
	import ApplicationsSettingsLoader from '@core/classes/Applications/ApplicationsSettingsLoader';
	import { getPrefilledData } from '@core/helpers/customer-application-helper';
	import LOCALIZATION from '@core/classes/Localization';

	//NOTE: This is the page where It says "start application", after the prefilled data page.
	export default {
		name: 'LoginSuccess',
		props: ['theme', 'sourceData', 'customerApp', 'fimenu', 'codeInfo'],
		data() {
			return {
				message1: null,
				message2: null,
				message3: null,
			};
		},
		computed: {
			hrefUrl() {
				const phoneNumber = this.customerApp.quoteAppData?.personalInfo?.phoneNumber ?? this.customerApp.preFilledData.phoneNumber;
				const phoneLastFour = phoneNumber.toString().slice(-4);

				return (
					'/customer-portal/phoneVerification?emailCode=' +
					this.customerApp.emailCode +
					'&storeCode=' +
					this.$route.query.storeCode +
					'&language=' +
					this.fimenu.language +
					'&isInStore=true' +
					'&lastFour=' +
					phoneLastFour
				);
			},
			localization() {
				return LOCALIZATION;
			},
		},
		async created() {
			this.message1 = this.getTextToShow(this.localization.creditApp.creationPage.createSuccessMessage[this.fimenu.language]);
			this.message2 = this.getTextToShow(this.localization.creditApp.creationPage.createSuccessMessageInStore1[this.fimenu.language]);
			this.message3 = this.getTextToShow(this.localization.creditApp.creationPage.createSuccessMessageInStore2[this.fimenu.language]);
		},

		methods: {
			getTextToShow(message) {
				const dataToReplace = ApplicationsSettingsLoader.ApplicationSettings.prefilledReplacements;
				ApplicationsSettingsLoader.ApplicationSettings.storeInfo.forEach(si => {
					dataToReplace.push(si);
				});
				const textToDisplay = getPrefilledData(dataToReplace, this.sourceData, message, this.fimenu.language);
				return textToDisplay;
			},
			getLogoToShow() {
				const logo = 'hello';
				return logo;
			},
		},
	};
</script>

<style></style>
